// @mui material components
import { Grid, Card } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
// Material Dashboard 2 React example components
import DataTable from "examples/Tables/DataTable";

// Data
// import { columns, rows } from "components/PropertyListTable/data";
import {
  fundingSourceColumns,
  DeactivatedUsersColumns,
} from "../../constants/columns.constants";

import useDeactivateUsersHook from "../../hooks/useDeactivateUsersHook";
import ConfirmModal from "../../components/ConfirmModal/ConfirmModal";

const DeactivatedUsersTable = () => {
  const {
    rows,
    isLoading,
    currentPage,
    setCurrentPage,
    isRemovalModal,
    isDeclineModal,
    closeRemovalModal,
    closeDeclineModal,
    removeFundingSource,
    declineFundingSourceRequest,
    isFundingSourceLoading,
    setPerPage,
    perPage,
    totalPage,
    totalCount,
    searchTerm,
    setSearchTerm,
  } = useDeactivateUsersHook();
  return (
    <MDBox pt={6}>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              variant="gradient"
              bgColor="error"
              borderRadius="lg"
              coloredShadow="info">
              <MDTypography variant="h6" color="white">
                Deactivated Users List
              </MDTypography>
            </MDBox>
            <MDBox
              sx={{
                position: "relative",
                paddingTop: "85px",
                paddingBottom: {
                  xs: "150px",
                  sm: "95px",
                },
              }}>
              <DataTable
                table={{
                  columns: DeactivatedUsersColumns,
                  rows: rows,
                }}
                canSearch
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                isSorted={true}
                entriesPerPage={true}
                showTotalEntries={true}
                isLoading={isLoading}
                perPage={perPage}
                setPerPage={setPerPage}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalPage={totalPage}
                totalRecords={totalCount}
                noEndBorder
              />
            </MDBox>
          </Card>
        </Grid>
      </Grid>
    </MDBox>
  );
};

export default DeactivatedUsersTable;
